<div class="container">
  <mat-card class="mat-card-form">
    <mat-card-header>
      <mat-card-subtitle class="uk-text-body-strong"
        >Generar código de autorización</mat-card-subtitle
      >
    </mat-card-header>
    <mat-card-content>
      <button
        id="exit2"
        mat-flat-button
        class="button-success m-2"
        (click)="generate()"
      >
        Generar
      </button>
      <!-- [selectable]="selectable"
      [removable]="removable" -->
      <mat-chip-set aria-label="Fruit selection">
        <mat-chip
          *ngFor="let cod of listCodeAuthorization"
          (removed)="remove(cod.value)"
          (click)="submit(cod.value)"
          [disabled]="!cod.state"
          [id]="cod.value"
        >
          {{ cod.value }}
          <mat-icon matChipRemove *ngIf="removable">filter_none</mat-icon>
        </mat-chip>
      </mat-chip-set>
    </mat-card-content>
  </mat-card>
</div>
